import styled from "styled-components";
import PolicySubjectResumeInfo from "./PolicySubjectResumeInfo";
import { useSubjectDetailsContext } from "./PolicySubjectDetailsContext";
import PolicySubjectTabs from "./PolicySubjectTabs";
import { IconLoading } from "../../../../../../../../config/icons";

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
  display: flex;
  justify-content: center;

  svg {
    width: 100px;
  }
  // .box {
  //   width: 10em;
  //   display: flex;
  //   justify-content: center;
  // }
`;

const PolicySubjectDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PolicySubjectDetails = () => {
  const { subject, status } = useSubjectDetailsContext();

  return (
    <>
      {["loading", "refreshing", "saving"].includes(status as string) && (
        <LoadingWrapper>{IconLoading}</LoadingWrapper>
      )}

      {
        // ["idle", "refreshing", "saving"].includes(status as string) &&
        subject && (
          <PolicySubjectDetailsWrapper>
            <PolicySubjectResumeInfo />

            <PolicySubjectTabs />
          </PolicySubjectDetailsWrapper>
        )
      }
    </>
  );
};

export default PolicySubjectDetails;
